/**
 * @file State persistence — localStorage + Supabase cloud sync
 * Adapted from Deploy Z store.js (~1700 lines) to ~200 lines.
 * Keeps: store/load, LZ compression, sbPush (debounced), sbPullAll, push guard.
 */

import { getClient } from './supabase.js';
import { emit } from '@core/events.js';

// =============================================
// LZ-STRING COMPRESSION (minimal inline — MIT License, pieroxy)
// Only compressToUTF16 / decompressFromUTF16
// =============================================
const _lz = (function () {
  const f = String.fromCharCode;
  function _compress(uncompressed, bitsPerChar, getCharFromInt) {
    if (uncompressed == null) return '';
    let i, value, context_c = '', context_wc = '', context_w = '';
    let context_enlargeIn = 2, context_dictSize = 3, context_numBits = 2;
    let context_data = [], context_data_val = 0, context_data_position = 0;
    const context_dictionary = {}, context_dictionaryToCreate = {};
    for (let ii = 0; ii < uncompressed.length; ii++) {
      context_c = uncompressed.charAt(ii);
      if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
        context_dictionary[context_c] = context_dictSize++;
        context_dictionaryToCreate[context_c] = true;
      }
      context_wc = context_w + context_c;
      if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) {
        context_w = context_wc;
      } else {
        if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
          if (context_w.charCodeAt(0) < 256) {
            for (i = 0; i < context_numBits; i++) { context_data_val <<= 1; if (context_data_position === bitsPerChar - 1) { context_data_position = 0; context_data.push(getCharFromInt(context_data_val)); context_data_val = 0; } else { context_data_position++; } }
            value = context_w.charCodeAt(0);
            for (i = 0; i < 8; i++) { context_data_val = (context_data_val << 1) | (value & 1); if (context_data_position === bitsPerChar - 1) { context_data_position = 0; context_data.push(getCharFromInt(context_data_val)); context_data_val = 0; } else { context_data_position++; } value >>= 1; }
          } else {
            value = 1;
            for (i = 0; i < context_numBits; i++) { context_data_val = (context_data_val << 1) | value; if (context_data_position === bitsPerChar - 1) { context_data_position = 0; context_data.push(getCharFromInt(context_data_val)); context_data_val = 0; } else { context_data_position++; } value = 0; }
            value = context_w.charCodeAt(0);
            for (i = 0; i < 16; i++) { context_data_val = (context_data_val << 1) | (value & 1); if (context_data_position === bitsPerChar - 1) { context_data_position = 0; context_data.push(getCharFromInt(context_data_val)); context_data_val = 0; } else { context_data_position++; } value >>= 1; }
          }
          context_enlargeIn--;
          if (context_enlargeIn === 0) { context_enlargeIn = Math.pow(2, context_numBits); context_numBits++; }
          delete context_dictionaryToCreate[context_w];
        } else {
          value = context_dictionary[context_w];
          for (i = 0; i < context_numBits; i++) { context_data_val = (context_data_val << 1) | (value & 1); if (context_data_position === bitsPerChar - 1) { context_data_position = 0; context_data.push(getCharFromInt(context_data_val)); context_data_val = 0; } else { context_data_position++; } value >>= 1; }
        }
        context_enlargeIn--;
        if (context_enlargeIn === 0) { context_enlargeIn = Math.pow(2, context_numBits); context_numBits++; }
        context_dictionary[context_wc] = context_dictSize++;
        context_w = String(context_c);
      }
    }
    if (context_w !== '') {
      if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
        if (context_w.charCodeAt(0) < 256) {
          for (i = 0; i < context_numBits; i++) { context_data_val <<= 1; if (context_data_position === bitsPerChar - 1) { context_data_position = 0; context_data.push(getCharFromInt(context_data_val)); context_data_val = 0; } else { context_data_position++; } }
          value = context_w.charCodeAt(0);
          for (i = 0; i < 8; i++) { context_data_val = (context_data_val << 1) | (value & 1); if (context_data_position === bitsPerChar - 1) { context_data_position = 0; context_data.push(getCharFromInt(context_data_val)); context_data_val = 0; } else { context_data_position++; } value >>= 1; }
        } else {
          value = 1;
          for (i = 0; i < context_numBits; i++) { context_data_val = (context_data_val << 1) | value; if (context_data_position === bitsPerChar - 1) { context_data_position = 0; context_data.push(getCharFromInt(context_data_val)); context_data_val = 0; } else { context_data_position++; } value = 0; }
          value = context_w.charCodeAt(0);
          for (i = 0; i < 16; i++) { context_data_val = (context_data_val << 1) | (value & 1); if (context_data_position === bitsPerChar - 1) { context_data_position = 0; context_data.push(getCharFromInt(context_data_val)); context_data_val = 0; } else { context_data_position++; } value >>= 1; }
        }
        context_enlargeIn--;
        if (context_enlargeIn === 0) { context_enlargeIn = Math.pow(2, context_numBits); context_numBits++; }
        delete context_dictionaryToCreate[context_w];
      } else {
        value = context_dictionary[context_w];
        for (i = 0; i < context_numBits; i++) { context_data_val = (context_data_val << 1) | (value & 1); if (context_data_position === bitsPerChar - 1) { context_data_position = 0; context_data.push(getCharFromInt(context_data_val)); context_data_val = 0; } else { context_data_position++; } value >>= 1; }
      }
      context_enlargeIn--;
      if (context_enlargeIn === 0) { context_enlargeIn = Math.pow(2, context_numBits); context_numBits++; }
    }
    value = 2;
    for (i = 0; i < context_numBits; i++) { context_data_val = (context_data_val << 1) | (value & 1); if (context_data_position === bitsPerChar - 1) { context_data_position = 0; context_data.push(getCharFromInt(context_data_val)); context_data_val = 0; } else { context_data_position++; } value >>= 1; }
    while (true) { context_data_val <<= 1; if (context_data_position === bitsPerChar - 1) { context_data.push(getCharFromInt(context_data_val)); break; } else { context_data_position++; } }
    return context_data.join('');
  }
  function _decompress(length, resetValue, getNextValue) {
    const dictionary = []; let enlargeIn = 4, dictSize = 4, numBits = 3, entry = '', result = [], w, c;
    const data = { val: getNextValue(0), position: resetValue, index: 1 };
    let bits, resb, maxpower, power;
    for (let i = 0; i < 3; i++) dictionary[i] = i;
    bits = 0; maxpower = Math.pow(2, 2); power = 1;
    while (power !== maxpower) { resb = data.val & data.position; data.position >>= 1; if (data.position === 0) { data.position = resetValue; data.val = getNextValue(data.index++); } bits |= (resb > 0 ? 1 : 0) * power; power <<= 1; }
    switch (bits) {
      case 0: bits = 0; maxpower = Math.pow(2, 8); power = 1; while (power !== maxpower) { resb = data.val & data.position; data.position >>= 1; if (data.position === 0) { data.position = resetValue; data.val = getNextValue(data.index++); } bits |= (resb > 0 ? 1 : 0) * power; power <<= 1; } c = f(bits); break;
      case 1: bits = 0; maxpower = Math.pow(2, 16); power = 1; while (power !== maxpower) { resb = data.val & data.position; data.position >>= 1; if (data.position === 0) { data.position = resetValue; data.val = getNextValue(data.index++); } bits |= (resb > 0 ? 1 : 0) * power; power <<= 1; } c = f(bits); break;
      case 2: return '';
    }
    dictionary[3] = c; w = c; result.push(c);
    while (true) {
      if (data.index > length) return '';
      bits = 0; maxpower = Math.pow(2, numBits); power = 1;
      while (power !== maxpower) { resb = data.val & data.position; data.position >>= 1; if (data.position === 0) { data.position = resetValue; data.val = getNextValue(data.index++); } bits |= (resb > 0 ? 1 : 0) * power; power <<= 1; }
      switch (c = bits) {
        case 0: bits = 0; maxpower = Math.pow(2, 8); power = 1; while (power !== maxpower) { resb = data.val & data.position; data.position >>= 1; if (data.position === 0) { data.position = resetValue; data.val = getNextValue(data.index++); } bits |= (resb > 0 ? 1 : 0) * power; power <<= 1; } dictionary[dictSize++] = f(bits); c = dictSize - 1; enlargeIn--; break;
        case 1: bits = 0; maxpower = Math.pow(2, 16); power = 1; while (power !== maxpower) { resb = data.val & data.position; data.position >>= 1; if (data.position === 0) { data.position = resetValue; data.val = getNextValue(data.index++); } bits |= (resb > 0 ? 1 : 0) * power; power <<= 1; } dictionary[dictSize++] = f(bits); c = dictSize - 1; enlargeIn--; break;
        case 2: return result.join('');
      }
      if (enlargeIn === 0) { enlargeIn = Math.pow(2, numBits); numBits++; }
      if (dictionary[c]) { entry = dictionary[c]; } else if (c === dictSize) { entry = w + w.charAt(0); } else { return null; }
      result.push(entry);
      dictionary[dictSize++] = w + entry.charAt(0);
      enlargeIn--;
      if (enlargeIn === 0) { enlargeIn = Math.pow(2, numBits); numBits++; }
      w = entry;
    }
  }
  return {
    compressToUTF16(input) { if (input == null) return ''; return _compress(input, 15, a => f(a + 32)) + ' '; },
    decompressFromUTF16(compressed) { if (compressed == null) return ''; if (compressed === '') return null; return _decompress(compressed.length, 16384, index => compressed.charCodeAt(index) - 32); }
  };
})();

// =============================================
// COMPRESSION HELPERS
// =============================================
const PREFIX = '\x01PBF_LZ\x01';
const THRESHOLD = 512;

function compressValue(serialized) {
  if (serialized.length < THRESHOLD) return serialized;
  try {
    const compressed = PREFIX + _lz.compressToUTF16(serialized);
    return compressed.length < serialized.length ? compressed : serialized;
  } catch (e) { return serialized; }
}

function decompressValue(raw) {
  if (!raw || !raw.startsWith(PREFIX)) return raw;
  try {
    const d = _lz.decompressFromUTF16(raw.substring(PREFIX.length));
    return d === null ? raw : d;
  } catch (e) { return raw; }
}

// =============================================
// STORE / LOAD — localStorage first, async cloud push
// =============================================
let _userId = null;
let _firstPullComplete = false;
const _pushTimers = {};
const PUSH_GUARD_KEYS = { customers: 1, saved_invoices: 1, pipeline: 1, jobs_pipeline: 1, crm_tasks: 1, leads: 1 };

export function setUserId(id) { _userId = id; }
export function getUserId() { return _userId; }
export function isFirstPullComplete() { return _firstPullComplete; }

/**
 * Write a key-value pair to localStorage and async push to Supabase.
 */
export function store(key, val) {
  if (typeof val === 'undefined') { console.error('[store] Blocked undefined write:', key); return; }
  const fullKey = 'pbf_' + key;
  const serialized = JSON.stringify(val);
  try {
    localStorage.setItem(fullKey, compressValue(serialized));
  } catch (e) {
    console.warn('[store] localStorage write error:', e.message);
  }
  sbPush(key, val);
}

/**
 * Read a key from localStorage.
 */
export function load(key, fallback) {
  try {
    const v = localStorage.getItem('pbf_' + key);
    if (!v) return fallback;
    return JSON.parse(decompressValue(v));
  } catch (e) { return fallback; }
}

/**
 * Debounced push to Supabase app_data table.
 */
export function sbPush(key, val) {
  const sb = getClient();
  if (!sb || !_userId || !_firstPullComplete) return;
  if (_pushTimers[key]) clearTimeout(_pushTimers[key]);
  _pushTimers[key] = setTimeout(() => {
    delete _pushTimers[key];
    _sbPushNow(key, val);
  }, 500);
}

async function _sbPushNow(key, val) {
  const sb = getClient();
  if (!sb || !_userId || !_firstPullComplete) return;

  // Push guard: refuse if local is drastically smaller than cloud
  if (PUSH_GUARD_KEYS[key]) {
    try {
      const { data: cloudRow } = await sb.from('app_data').select('value').eq('user_id', _userId).eq('key', key).single();
      if (cloudRow && cloudRow.value != null) {
        const cv = cloudRow.value, lv = val;
        let cloudCount = 0, localCount = 0;
        if (Array.isArray(cv) && Array.isArray(lv)) { cloudCount = cv.length; localCount = lv.length; }
        else if (cv && typeof cv === 'object' && lv && typeof lv === 'object' && !Array.isArray(cv)) {
          cloudCount = Object.values(cv).reduce((s, a) => s + (Array.isArray(a) ? a.length : 0), 0);
          localCount = Object.values(lv).reduce((s, a) => s + (Array.isArray(a) ? a.length : 0), 0);
        }
        if (cloudCount > 5 && localCount < cloudCount * 0.5) {
          console.warn(`[store] Push blocked: "${key}" local=${localCount} cloud=${cloudCount}`);
          return;
        }
      }
    } catch (e) { /* guard is best-effort */ }
  }

  try {
    const { error } = await sb.from('app_data').upsert({
      user_id: _userId, key, value: val, updated_at: new Date().toISOString()
    }, { onConflict: 'user_id,key' });
    if (error) console.warn('[store] Push failed:', key, error.message);
    else emit('sync:pushed', { key });
  } catch (e) {
    console.warn('[store] Push error:', e.message);
  }
}

/**
 * Pull all data from Supabase cloud -> localStorage.
 */
export async function sbPullAll() {
  const sb = getClient();
  if (!sb || !_userId) return;
  emit('sync:status', 'syncing');

  try {
    const { data, error } = await sb.from('app_data').select('key, value, updated_at').eq('user_id', _userId);
    if (error) {
      console.warn('[store] Pull failed:', error.message);
      emit('sync:status', 'error');
      _firstPullComplete = true;
      return;
    }
    if (!data || data.length === 0) {
      _firstPullComplete = true;
      emit('sync:status', 'synced');
      return;
    }

    let pulled = 0;
    data.forEach(row => {
      if (row.value === null || row.value === undefined) return;
      // Fix pipeline shape
      if ((row.key === 'pipeline' || row.key === 'jobs_pipeline') && Array.isArray(row.value)) {
        row.value = {};
      }
      localStorage.setItem('pbf_' + row.key, compressValue(JSON.stringify(row.value)));
      pulled++;
    });

    store('_sb_last_sync', Date.now());
    store('_current_user_id', _userId);
    _firstPullComplete = true;
    emit('sync:status', 'synced');
    emit('sync:pulled', { count: pulled });
    console.log(`[store] Pulled ${pulled} items from cloud`);
  } catch (e) {
    console.warn('[store] Pull error:', e.message);
    emit('sync:status', 'error');
    _firstPullComplete = true;
  }
}

/**
 * Get localStorage usage stats.
 */
export function getStorageUsage() {
  let total = 0;
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i);
    if (!k) continue;
    total += ((localStorage.getItem(k) || '').length + k.length) * 2;
  }
  return {
    totalBytes: total,
    totalMB: (total / 1024 / 1024).toFixed(2),
    usedPct: Math.round(total / (5 * 1024 * 1024) * 100),
  };
}
